webpackJsonp([114276838955818,60335399758886],{

/***/ 128:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(274);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(128);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(22);
	
	var _grayPercentage = __webpack_require__(24);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var links = [['Twitter', 'https://twitter.com/soska'], ['Instagram', 'https://instagram.com/soska'], ['Dribbble', 'https://dribbble.com/soska'], ['Github', 'https://github.com/soska']];
	
	var FooterLink = function FooterLink(_ref) {
	  var link = _ref.link;
	  var label = link[0],
	      url = link[1];
	
	  return Glamor.createElement(
	    'a',
	    {
	      css: {
	        padding: (0, _typography.rhythm)(0.25),
	        margin: (0, _typography.rhythm)(0.25)
	      },
	      href: url
	    },
	    label
	  );
	};
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return Glamor.createElement(
	      'div',
	      {
	        css: {
	          padding: (0, _typography.rhythm)(1),
	          display: 'flex',
	          justifyContent: 'center',
	          borderTop: '1px solid ' + (0, _grayPercentage2.default)(90),
	          background: 'white'
	        }
	      },
	      links.map(function (link) {
	        return Glamor.createElement(FooterLink, { link: link });
	      })
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(22);
	
	var _grayPercentage = __webpack_require__(24);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = function (_React$Component) {
	  _inherits(Logo, _React$Component);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Logo.prototype.render = function render() {
	    return Glamor.createElement(
	      'div',
	      {
	        css: {
	          padding: '22px',
	          textAlign: 'center',
	          background: 'white',
	          borderBottom: '1px solid ' + (0, _grayPercentage2.default)(90)
	        }
	      },
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        Glamor.createElement(
	          'svg',
	          { css: { width: '50px' }, viewBox: '0 0 800 800' },
	          Glamor.createElement('defs', null),
	          Glamor.createElement('path', {
	            css: { fill: 'tomato' },
	            d: 'M799.86,114.54V.25H-.14V343.11h684V459H-.14V800.25h800V228.82H115.31V114.54ZM115.31,686V573.27H683.83V686Z'
	          })
	        )
	      )
	    );
	  };
	
	  return Logo;
	}(_react2.default.Component);
	
	exports.default = Logo;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _footer = __webpack_require__(272);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _logo = __webpack_require__(273);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _grayPercentage = __webpack_require__(24);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _typography = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(381);
	
	var Header = function Header() {
	  return Glamor.createElement(
	    'h1',
	    {
	      style: _extends({}, (0, _typography.scale)(1.5), {
	        marginBottom: (0, _typography.rhythm)(1.5),
	        marginTop: 0
	      })
	    },
	    Glamor.createElement(
	      _gatsbyLink2.default,
	      {
	        style: {
	          boxShadow: 'none',
	          textDecoration: 'none',
	          color: 'tomato'
	        },
	        to: '/'
	      },
	      'Hola!'
	    )
	  );
	};
	
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      children = _ref.children;
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    {
	      css: {
	        fontSize: (0, _typography.rhythm)(0.45),
	        textTransform: 'uppercase',
	        letterSpacing: '0.04em',
	        display: 'block',
	        padding: (0, _typography.rhythm)(0.5),
	        color: (0, _grayPercentage2.default)(40),
	        '&:hover': {
	          color: 'tomato'
	        }
	      },
	      to: to
	    },
	    children
	  );
	};
	
	var Nav = function Nav() {
	  return Glamor.createElement(
	    'nav',
	    {
	      css: {
	        display: 'flex',
	        justifyContent: 'center',
	        borderBottom: '1px solid ' + (0, _grayPercentage2.default)(95)
	      }
	    },
	    Glamor.createElement(
	      NavLink,
	      { to: '/' },
	      'Home'
	    ),
	    Glamor.createElement(
	      NavLink,
	      { to: '/about' },
	      'About'
	    ),
	    Glamor.createElement(
	      NavLink,
	      { to: '/projects' },
	      'Projects'
	    )
	  );
	};
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var header = void 0;
	
	    var rootPath = '/';
	    if (false) {
	      rootPath = __PATH_PREFIX__ + '/';
	    }
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(_logo2.default, null),
	      Glamor.createElement(Nav, null),
	      Glamor.createElement(
	        'div',
	        {
	          style: {
	            marginLeft: 'auto',
	            marginRight: 'auto',
	            maxWidth: (0, _typography.rhythm)(28),
	            minHeight: '80vh',
	            padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4)
	          }
	        },
	        location.pathname === rootPath && Glamor.createElement(Header, null),
	        children()
	      ),
	      Glamor.createElement(_footer2.default, null)
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-355d4138ee08cb774d86.js